"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _constants = require("../../assets/js/constants");

var themes = {
  bordered: {
    background: _constants.COLORS.white,
    borderWidth: '1px',
    radius: '4px',
    padding: '20px',
    mobilePadding: '15px',
    color: _constants.COLORS.black
  },
  simple: {
    background: 'transparent',
    borderWidth: '1px 0',
    radius: '0px',
    padding: '20px 0',
    mobilePadding: '15px 0',
    color: _constants.COLORS.black
  }
};
var _default = themes;
exports["default"] = _default;